import React from "react";
import { supabase } from "../../Services/supabaseClient";
import { NavLink, useNavigate } from "react-router-dom";

const CRMSidebar = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/dashboard");
  };

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut({ scope: "global" });

      localStorage.clear();
      sessionStorage.clear();

      window.location.replace("/login");
    } catch (error) {
      console.error("Logout error:", error);
      window.location.replace("/login");
    }
  };

  return (
    <aside className="crm-sidebar">
      <div className="crm-sidebar-brand">
        <div className="crm-brand-badge">KP</div>
        <div>
          <h2 className="crm-brand-title">KostPadi CRM</h2>
          <p className="crm-brand-subtitle">Sales & Customer Hub</p>
        </div>
      </div>

      <button className="crm-back-btn" onClick={handleBack}>
        ← Back to Main App
      </button>

      <nav className="crm-sidebar-nav">
        <NavLink
          to="/crm"
          end
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Overview
        </NavLink>

        <NavLink
          to="/crm/dashboard"
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Dashboard
        </NavLink>

        <NavLink
          to="/crm/forecast"
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Forecast
        </NavLink>

        <NavLink
          to="/crm/leads"
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Leads
        </NavLink>

        <NavLink
          to="/crm/accounts"
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Accounts
        </NavLink>

        <NavLink
          to="/crm/contacts"
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Contacts
        </NavLink>

        <NavLink
          to="/crm/opportunities"
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Opportunities
        </NavLink>

        <NavLink
          to="/crm/quotes"
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Quotes
        </NavLink>

        <NavLink
          to="/crm/collections"
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Collections
        </NavLink>

        <NavLink
          to="/crm/settings"
          className={({ isActive }) =>
            isActive ? "crm-nav-link active" : "crm-nav-link"
          }
        >
          Settings
        </NavLink>
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </aside>
  );
};

export default CRMSidebar;
